export default "__VITE_ASSET__BNnJPUMD__"